//ユーザーCSVアップロードページ
import React, { Fragment, useState, useRef, useEffect } from 'react';
import {
  Typography,
  Button,
  Form,
  message,
  Input,
  Select,
  Upload,
  Tag,
  theme,
  Progress,
  Modal,
  Spin,
} from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { TweenOneGroup } from 'rc-tween-one';
import Axios from 'axios';
// 動画アップロードは Vimeo SDK のクライアント直接利用を廃止し、サーバー経由
// （POST /api/video/upload）に移行した。これにより Vimeo のシークレットは
// サーバーの .env にのみ存在し、フロントエンドのバンドルには露出しない。
// サムネールは従来どおり presigned URL で S3 へ直接アップロードする。
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

function VideoUploadPage(props) {
  const { token } = theme.useToken();
  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  const [videoCategory, setVideoCategory] = useState([]); //グループ名とグループコード
  const [instructor, setInstructor] = useState([]); //グループにあるサーベイシーズン
  const [videoFileList, setVideoFileList] = useState([]);
  const [thumbnailList, setThumbnailList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [value, setValue] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  // アップロード失敗時のエラーメッセージ（モーダル内に表示し、OK で閉じられるようにする）
  const [uploadError, setUploadError] = useState(null);
  const [instructorModalVisible, setInstructorModalVisible] = useState(false);
  const [newInstructor, setNewInstructor] = useState({ name: '' });
  // 動画カテゴリ新規登録モーダル用
  const [categoryModalVisible, setCategoryModalVisible] = useState(false);
  const [newCategory, setNewCategory] = useState({
    category_name: '',
    category_description: '',
  });
  const { user } = props;

  // const s3 = new AWS.S3({
  //   // const s3 = new S3({
  //   accessKeyId: config.AWS_ACCESS_KEY,
  //   secretAccessKey: config.AWS_SECRET_KEY,
  //   signatureVersion: 'v4',
  //   region: config.AWS_REGION,
  // });
  // const makeS3Instance = async () => {
  //   const aksk = await Axios.get(`/api/projectKey/aksk`);
  //   console.log({ aksk });
  //   const s3 = new AWS.S3({
  //     accessKeyId: aksk.data.ak,
  //     secretAccessKey: aksk.data.sk,
  //     signatureVersion: 'v4',
  //     region: config.AWS_REGION,
  //   });
  //   return s3;
  // };
  // const s3 = makeS3Instance();

  // AWS.config.update({ region: config.AWS_REGION });
  // var roleCreds;

  // // Create the STS service object
  // var sts = new AWS.STS({ apiVersion: '2011-06-15' });

  // //Assume Role
  // sts.assumeRole(roleToAssume, function (err, data) {
  //   if (err) console.log(err, err.stack);
  //   else {
  //     roleCreds = {
  //       accessKeyId: data.Credentials.AccessKeyId,
  //       secretAccessKey: data.Credentials.SecretAccessKey,
  //       sessionToken: data.Credentials.SessionToken,
  //     };
  //     stsGetCallerIdentity(roleCreds);
  //   }
  // });

  // const s3 = new AWS.S3(roleCreds);

  //Get Arn of current identity
  // function stsGetCallerIdentity(creds) {
  //   var stsParams = { credentials: creds };
  //   // Create STS service object
  //   var sts = new AWS.STS(stsParams);

  //   sts.getCallerIdentity({}, function (err, data) {
  //     if (err) {
  //       console.log(err, err.stack);
  //     } else {
  //       console.log(data.Arn);
  //     }
  //   });
  // }

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        // const [vc, inst] = await Promise.all([
        //   Axios.get('/api/videoCategory/'),
        //   Axios.get('/api/instructor/'),
        // ]);
        const vc = await Axios.get('/api/videoCategory/');
        const inst = await Axios.get('/api/instructor/');
        // console.log(vc.data.videoCategory);
        // console.log(inst.data.instructor);
        // const aksk = await Axios.get(`/api/projectKey/aksk`);
        // console.log({ aksk });
        // s3 = new AWS.S3({
        //   accessKeyId: aksk.data.ak,
        //   secretAccessKey: aksk.data.sk,
        //   signatureVersion: 'v4',
        //   region: config.AWS_REGION,
        // });
        if (vc.data.success && inst.data.success) {
          setVideoCategory(vc.data.videoCategory);
          setInstructor(inst.data.instructor);
        } else {
          throw new Error('ビデオカテゴリ取得に失敗しました。');
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // if (!user.userData) return null;
    // console.log({ user });
    readDB();
    if (inputVisible) {
      inputRef.current.focus();
    }
  }, [user]);

  //AntdのUpload
  const uploadVideoFile = {
    onRemove: (file) => {
      const index = videoFileList.indexOf(file);
      const newFileList = videoFileList.slice();
      newFileList.splice(index, 1);
      setVideoFileList(newFileList);
      // 動画ファイルが削除されたら時間をリセット
      setValue({ ...value, duration_h: '', duration_m: '', duration_s: '' });
    },
    beforeUpload: (file) => {
      // .mp4 のみ許可（選択ミス防止）。type が空でも拡張子で判定する。
      const isMp4 =
        file.type === 'video/mp4' || file.name.toLowerCase().endsWith('.mp4');
      if (!isMp4) {
        message.error('動画は .mp4 ファイルのみ選択できます。');
        return Upload.LIST_IGNORE;
      }
      setVideoFileList([...videoFileList, file]);

      // 動画の再生時間を自動取得
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        const duration = Math.floor(video.duration);
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = duration % 60;

        setValue({
          ...value,
          duration_h: hours.toString(),
          duration_m: minutes.toString(),
          duration_s: seconds.toString(),
        });
      };

      video.onerror = () => {
        console.log('動画のメタデータ読み取りに失敗しました');
      };

      video.src = URL.createObjectURL(file);

      return false;
    },
    videoFileList,
  };
  const uploadThumbnail = {
    onRemove: (file) => {
      const index = thumbnailList.indexOf(file);
      const newFileList = thumbnailList.slice();
      newFileList.splice(index, 1);
      setThumbnailList(newFileList);
    },
    beforeUpload: (file) => {
      // .jpg / .jpeg / .png のみ許可（選択ミス防止）。type が空でも拡張子で判定する。
      const isImage =
        ['image/jpeg', 'image/png'].includes(file.type) ||
        /\.(jpg|jpeg|png)$/i.test(file.name);
      if (!isImage) {
        message.error('サムネールは .jpg / .jpeg / .png ファイルのみ選択できます。');
        return Upload.LIST_IGNORE;
      }
      setThumbnailList([...thumbnailList, file]);
      // console.log(file);
      return false;
    },
    thumbnailList,
  };

  // 動画アップロード（サーバー経由）
  // 動画ファイル本体を multipart/form-data でバックエンドへ送信し、
  // バックエンドが Vimeo SDK でアップロードして動画 URI を返す。
  // 進捗バーはクライアント→サーバー間の転送量を表示する。
  const vimeoUpload = async (sendData) => {
    try {
      const file = videoFileList[0];

      // Step 1: 動画ファイルをバックエンドへ送信して Vimeo アップロードを依頼
      const formData = new FormData();
      formData.append('video', file);
      formData.append('title', sendData.title || '');
      formData.append('description', sendData.video_explanation || '');

      const uploadRes = await Axios.post('/api/video/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        // 大容量動画に備えてサイズ上限を解除
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        onUploadProgress: (e) => {
          if (e.total) {
            const percentage = ((e.loaded / e.total) * 100).toFixed(2);
            setUploadProgress(percentage);
          }
        },
      });

      if (!uploadRes.data.success) {
        throw new Error(uploadRes.data.error || '動画アップロードに失敗しました。');
      }
      sendData.url = uploadRes.data.uri;

      // Step 2: サムネールをPresigned URL方式でアップロード
      for (let i = 0; i < thumbnailList.length; i++) {
        try {
          // Step 2-1: サーバーからPresigned URL取得
          const presignedResponse = await Axios.post(
            '/api/presignedUrl/thumbnail',
            {
              fileName: thumbnailList[i].name,
              fileType: thumbnailList[i].type,
              fileSize: thumbnailList[i].size,
              vimeoUri: sendData.url,
            }
          );

          if (!presignedResponse.data.success) {
            const errorMsg =
              presignedResponse.data.error || 'Presigned URL取得に失敗しました';
            throw new Error(errorMsg);
          }

          // Step 2-2: Presigned URLを使用してS3に直接アップロード
          const uploadResponse = await fetch(presignedResponse.data.uploadUrl, {
            method: 'PUT',
            body: thumbnailList[i],
            headers: {
              'Content-Type': thumbnailList[i].type,
            },
          });

          if (!uploadResponse.ok) {
            throw new Error(
              `サムネールアップロードに失敗しました: ${uploadResponse.statusText}`
            );
          }

          // Step 2-3: アップロード成功したファイルのURLを保存
          sendData.thumbnail.push(presignedResponse.data.fileUrl);
        } catch (err) {
          console.error('サムネールアップロードエラー:', err);
          throw new Error(`サムネール ${i + 1} のアップロードに失敗しました`);
        }
      }

      // Step 3: 動画メタデータを保存
      const res = await Axios.post('/api/video', sendData);

      if (res.data.success) {
        message.success({
          content: '動画アップロード完了',
          key: 'csvupload',
          duration: 2,
        });
        setButtonDisabled(false);
      } else {
        throw new Error('動画アップロードに失敗しました。');
      }
    } catch (error) {
      // サーバーが 400/500 で返すエラーメッセージ（error.response.data.error）を優先表示。
      // 無ければ Axios 既定の汎用メッセージ（"Request failed with status code 400" 等）。
      const serverMsg = error.response?.data?.error;
      console.log({ error, serverMsg });
      message.error({
        content: serverMsg || error.message,
        key: 'csvupload',
        duration: 5,
      });
      // 失敗をモーダルに表示し、OK で閉じられるようボタンを有効化（スピナーで固まらせない）
      setUploadError(serverMsg || error.message || '動画アップロードに失敗しました。');
      setButtonDisabled(false);
      return error;
    }
  };

  //yyyymmddhhmmss
  const ymdhms = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      ('0' + date.getDate()).slice(-2) +
      ('0' + date.getHours()).slice(-2) +
      ('0' + date.getMinutes()).slice(-2) +
      ('0' + date.getSeconds()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    // console.log(event);
    // let userData = []; //最終分類用
    try {
      if (
        !value.instructor ||
        !value.videoName ||
        !value.videoCategory ||
        videoFileList.length === 0 ||
        thumbnailList.length === 0
      )
        throw new Error('必須項目が入力されていません');
      message.loading({
        content: '動画アップロード中...',
        key: 'csvupload',
        duration: 20,
      });
      let sendData = [];
      // console.log({ value });
      // console.log({ videoFileList });
      // console.log({ thumbnailList });
      // console.log({ tags });
      sendData = {
        title: value.videoName,
        url: '',
        tag: tags,
        category_code_id: value.videoCategory,
        // category_code: videoCategory.find(
        //   (item) => item._id === value.videoCategory
        // ).category_code,
        video_description: value.videoDescription,
        video_explanation: value.videoExplanation,
        instructor: value.instructor,
        duration_h: value.duration_h,
        duration_m: value.duration_m,
        duration_s: value.duration_s,
        thumbnail: [],
      };
      // console.log({ thumbnailList });
      setUploadError(null); // 前回のエラー表示をクリア
      setButtonDisabled(true);
      setModalVisible(true);
      const res = await vimeoUpload(sendData);

      // console.log({ res });
      // const [res2, res3] = await Promise.all([
      //   Axios.post('/api/relation360', sendData),
      //   Axios.post('/api/surveyToken/ticket', sendToken),
      // ]);

      // if (res2.data.success && res3.data.success) {
      //   // if (0) {
      //   setFileData('CSVアップロードが完了しました。');
      //   message.success({
      //     content: 'アップロード完了！',
      //     key: 'csvupload',
      //     duration: 3,
      //   });
      //   setTimeout(() => {
      //     props.history.push('/');
      //   }, 1000);
      // } else {
      //   message.error({
      //     content: 'CSVアップロードに失敗しました。',
      //     key: 'csvupload',
      //     duration: 3,
      //   });
      //   throw new Error('CSVアップロードに失敗しました。');
      // }
    } catch (error) {
      const serverMsg = error.response?.data?.error;
      console.log({ error, serverMsg });
      message.error({
        content: serverMsg || error.message,
        key: 'csvupload',
        duration: 5,
      });
    }
  };

  const onChangeVideoName = (e) => {
    setValue({ ...value, videoName: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeDuration_h = (e) => {
    setValue({ ...value, duration_h: e.currentTarget.value });
  };
  const onChangeDuration_m = (e) => {
    setValue({ ...value, duration_m: e.currentTarget.value });
  };
  const onChangeDuration_s = (e) => {
    setValue({ ...value, duration_s: e.currentTarget.value });
  };
  const onChangeExpl = (e) => {
    setValue({ ...value, videoExplanation: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeDesc = (e) => {
    setValue({ ...value, videoDescription: e.currentTarget.value });
    // console.log(value);
  };

  const onChangeVideoCategory = (v) => {
    setValue({ ...value, videoCategory: v });
  };

  const onChangeInstructor = (v) => {
    setValue({ ...value, instructor: v });
  };

  // 新規講師登録
  const handleAddInstructor = async () => {
    try {
      if (!newInstructor.name) {
        message.error('講師名は必須です');
        return;
      }
      const res = await Axios.post('/api/instructor/', newInstructor);
      if (res.data.success) {
        message.success('講師を登録しました');
        // 講師リストを再読み込み
        const inst = await Axios.get('/api/instructor/');
        if (inst.data.success) {
          setInstructor(inst.data.instructor);
          // 新規登録した講師を自動選択
          setValue({ ...value, instructor: res.data.instructor._id });
        }
        setInstructorModalVisible(false);
        setNewInstructor({ name: '' });
      }
    } catch (error) {
      console.log(error);
      message.error('講師登録に失敗しました');
    }
  };

  // 新規動画カテゴリ登録（category_code はサーバー側で自動採番）
  const handleAddCategory = async () => {
    try {
      if (!newCategory.category_name) {
        message.error('カテゴリ名は必須です');
        return;
      }
      const res = await Axios.post('/api/videoCategory/', newCategory);
      if (res.data.success) {
        message.success('カテゴリを登録しました');
        // カテゴリリストを再読み込み
        const vc = await Axios.get('/api/videoCategory/');
        if (vc.data.success) {
          setVideoCategory(vc.data.videoCategory);
          // 新規登録したカテゴリを自動選択
          setValue({ ...value, videoCategory: res.data.videoCategory._id });
        }
        setCategoryModalVisible(false);
        setNewCategory({ category_name: '', category_description: '' });
      }
    } catch (error) {
      console.log(error);
      message.error('カテゴリ登録に失敗しました');
    }
  };

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    // console.log(newTags);
    setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };
  const forMap = (tag) => {
    const tagElem = (
      <Tag
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag}
      </Tag>
    );
    return (
      <span
        key={tag}
        style={{
          display: 'inline-block',
        }}
      >
        {tagElem}
      </span>
    );
  };
  const tagChild = tags.map(forMap);
  const tagPlusStyle = {
    background: token.colorBgContainer,
    borderStyle: 'dashed',
  };

  const handleModalOk = async (e) => {
    const hadError = !!uploadError;
    setModalVisible(false);
    setButtonDisabled(true);
    setUploadProgress(0);
    setUploadError(null);
    // 成功時のみ画面をリセット（再読み込み）。失敗時はフォーム入力を保持して再試行できるよう留まる。
    if (!hadError) {
      props.history.push('/videoupload');
    }
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>動画アップロード</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <div>
            <br />
            <Text strong>■ 動画ファイル選択：１個（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Upload {...uploadVideoFile} accept=".mp4">
                <Button icon={<UploadOutlined />}>動画ファイル選択</Button>
              </Upload>
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 動画名（必須）</Text>
            <div
              style={{ display: 'flex', justifyContent: 'space-between' }}
            ></div>
            <Input
              placeholder="動画名（必須）"
              name="mt_name"
              allowClear
              onChange={onChangeVideoName}
              value={value['videoName']}
            />
          </div>
          <div>
            <br />
            <Text strong>■ 再生時間（必須）</Text>
            <br />
            <Input
              style={{ marginLeft: 0, marginRight: 10, width: 80 }}
              placeholder="時間"
              name="duration_h"
              allowClear
              onChange={onChangeDuration_h}
              value={value['duration_h']}
            />
            時間　
            <Input
              style={{ marginLeft: 0, marginRight: 10, width: 80 }}
              placeholder="分"
              name="duration_m"
              allowClear
              onChange={onChangeDuration_m}
              value={value['duration_m']}
            />
            分　
            <Input
              style={{ marginLeft: 0, marginRight: 10, width: 80 }}
              placeholder="秒"
              name="duration_m"
              allowClear
              onChange={onChangeDuration_s}
              value={value['duration_s']}
            />
            秒
          </div>
          <div>
            <br />
            <Text strong>■ 動画カテゴリ選択（必須）</Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="動画カテゴリ選択"
                optionFilterProp="children"
                onChange={onChangeVideoCategory}
                value={value['videoCategory']}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {videoCategory.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.category_name}
                    </Option>
                  );
                })}
              </Select>
              <Button
                icon={<PlusOutlined />}
                onClick={() => setCategoryModalVisible(true)}
              >
                新規登録
              </Button>
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 講師選択（必須）</Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="講師選択"
                optionFilterProp="children"
                onChange={onChangeInstructor}
                value={value['instructor']}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {instructor.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.name}
                    </Option>
                  );
                })}
              </Select>
              <Button
                icon={<PlusOutlined />}
                onClick={() => setInstructorModalVisible(true)}
              >
                新規登録
              </Button>
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 動画タイトル：ユーザ向け（表示用）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <TextArea
                rows={3}
                onChange={onChangeExpl}
                value={value['videoExplanation']}
              />
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 動画説明：管理向け</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <TextArea
                rows={3}
                onChange={onChangeDesc}
                value={value['videoDescription']}
              />
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ サムネール選択：複数可</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Upload {...uploadThumbnail} accept=".jpg,.jpeg,.png">
                <Button icon={<UploadOutlined />}>
                  サムネールファイル選択
                </Button>
              </Upload>
            </div>
          </div>

          <div>
            <br />
            <Text strong>■ Tag記入</Text>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
            <div
              style={{
                marginBottom: 16,
              }}
            >
              <TweenOneGroup
                enter={{
                  scale: 0.8,
                  opacity: 0,
                  type: 'from',
                  duration: 100,
                }}
                onEnd={(e) => {
                  if (e.type === 'appear' || e.type === 'enter') {
                    e.target.style = 'display: inline-block';
                  }
                }}
                leave={{
                  opacity: 0,
                  width: 0,
                  scale: 0,
                  duration: 200,
                }}
                appear={false}
              >
                {tagChild}
              </TweenOneGroup>
            </div>
            <div>
              {inputVisible ? (
                <Input
                  ref={inputRef}
                  type="text"
                  size="small"
                  style={{
                    width: 78,
                  }}
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={handleInputConfirm}
                  onPressEnter={handleInputConfirm}
                />
              ) : (
                <Tag onClick={showInput} style={tagPlusStyle}>
                  <PlusOutlined /> New Tag
                </Tag>
              )}
            </div>
            {/* </div> */}
          </div>

          <Button
            type="primary"
            onClick={onSubmit}
            disabled={
              videoFileList.length === 0 ||
              value['videoName'] === '' ||
              value['videoCategory'] === ''
            }
            loading={uploading}
            size="large"
            style={{
              marginTop: 16,
            }}
          >
            {uploading ? 'アップロード中' : 'アップロード開始'}
          </Button>
        </Form>
        <Modal
          title="動画アップロード"
          open={modalVisible}
          onOk={handleModalOk}
          footer={[
            <Button
              key="submit"
              type="primary"
              disabled={buttonDisabled}
              onClick={handleModalOk}
            >
              {uploadError ? '閉じる' : 'OK'}
            </Button>,
          ]}
        >
          <div
            style={{
              height: '12em',
              position: 'relative',
            }}
          >
            <div
              style={{
                margin: '0',
                height: '10em',
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
              }}
            >
              {uploadError ? (
                // 失敗時はスピナーを止め、エラー内容を表示して「閉じる」で抜けられるようにする。
                <div style={{ color: 'var(--red-active)' }}>
                  アップロードに失敗しました。
                  <br />
                  <br />
                  <span style={{ wordBreak: 'break-all' }}>{uploadError}</span>
                </div>
              ) : uploadProgress < 100 ? (
                <>
                  アップロード中...
                  <br />
                  <br />
                  <Progress type="circle" percent={Number(uploadProgress)} />
                </>
              ) : buttonDisabled ? (
                // 転送完了（100%）後も Vimeo 側の処理完了を待つ。
                // 静止した 100% 円だとフリーズに見えるため、スピナー + 待機案内を表示する。
                <>
                  Vimeo処理中...
                  <br />
                  動画を登録しています。
                  <br />
                  画面を閉じずにしばらくお待ちください。
                  <br />
                  <br />
                  <Spin size="large" />
                </>
              ) : (
                <>
                  アップロード完了
                  <br />
                  <br />
                  <Progress type="circle" percent={100} />
                </>
              )}
            </div>
          </div>
        </Modal>
        <Modal
          title="講師新規登録"
          open={instructorModalVisible}
          onOk={handleAddInstructor}
          onCancel={() => {
            setInstructorModalVisible(false);
            setNewInstructor({ name: '' });
          }}
          okText="登録"
          cancelText="キャンセル"
        >
          <div style={{ marginBottom: 16 }}>
            <Text strong>講師名（必須）</Text>
            <Input
              placeholder="講師名"
              value={newInstructor.name}
              onChange={(e) =>
                setNewInstructor({ ...newInstructor, name: e.target.value })
              }
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>メールアドレス</Text>
            <Input
              placeholder="メールアドレス"
              value={newInstructor.email}
              onChange={(e) =>
                setNewInstructor({ ...newInstructor, email: e.target.value })
              }
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>専門分野</Text>
            <Input
              placeholder="専門分野"
              value={newInstructor.sector}
              onChange={(e) =>
                setNewInstructor({ ...newInstructor, sector: e.target.value })
              }
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>メモ</Text>
            <Input
              placeholder="メモ"
              value={newInstructor.description}
              onChange={(e) =>
                setNewInstructor({ ...newInstructor, description: e.target.value })
              }
            />
          </div>
        </Modal>
        <Modal
          title="動画カテゴリ新規登録"
          open={categoryModalVisible}
          onOk={handleAddCategory}
          onCancel={() => {
            setCategoryModalVisible(false);
            setNewCategory({ category_name: '', category_description: '' });
          }}
          okText="登録"
          cancelText="キャンセル"
        >
          <div style={{ marginBottom: 16 }}>
            <Text strong>カテゴリ名（必須）</Text>
            <Input
              placeholder="カテゴリ名"
              value={newCategory.category_name}
              onChange={(e) =>
                setNewCategory({ ...newCategory, category_name: e.target.value })
              }
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>説明</Text>
            <Input
              placeholder="説明"
              value={newCategory.category_description}
              onChange={(e) =>
                setNewCategory({
                  ...newCategory,
                  category_description: e.target.value,
                })
              }
            />
          </div>
        </Modal>
      </div>
    </Fragment>
  );
}

export default VideoUploadPage;
